import filesize from 'filesize';
import Mustache from 'mustache'

function check_url_exists(url) {
  return new Promise((resolve, reject) => {
    var http = new XMLHttpRequest();
    http.open('HEAD', url);
    http.onreadystatechange = function() {
        if (this.readyState == this.DONE) {
          if(this.status == 200) {
            resolve();
          } else {
            reject(this.status);
          }
        }
    };
    try {
      http.send();
    } catch(e) {
      console.log(e);
    }
  });
}

export default {
  get_title(clip, default_text) {
    return _.get(clip, ["meta", "quality", "title"], default_text||"");
  },
  get_subtitle(clip, default_text) {
    var size = _.get(clip, ["meta", "filesize"], 0);
    return "Size: "+(!isNaN(size) ? filesize(size) : "Unknown");
  },
  get_name(clip, default_text) {
    return _.get(clip, ["meta", "quality", "name"], default_text||"0");
  },
  open(clip, download) {
    return new Promise((resolve, reject) => {
      if (clip.status == "ready") {
        check_url_exists(clip.url).then(
          () => {
            if(download) {
              var clip_url = new URL(clip.url);
              var elem = document.createElement("iframe");
              elem.src = clip_url.protocol + "//" + clip_url.host + "/dl.html?uuid=" + clip.uuid;
              elem.style.display = "none";
              elem.onload = function() {
                setTimeout(function() { document.body.removeChild(elem); }, 1000);
              }
              document.body.appendChild(elem);
            } else {
              let newTab = window.open();
              if(newTab == null) {
                window.location = clip.url;
              } else {
                newTab.location.href = clip.url;
              }
            }
            resolve();
          },
          () => {
            reject();
          }
        )
      }
    });
  }
}
